import { Outlet, useLocation } from "react-router-dom";
import CustomerHeader from "./CustomerHeader";
import CustomerFooter from "./CustomerFooter";
import MobileBottomNav from "./MobileBottomNav";
import MiniCart from "./MiniCart";

export default function CustomerShell() {
  const loc = useLocation();
  return (
    <div className="min-h-screen flex flex-col bg-background" data-testid="customer-shell">
      <CustomerHeader />
      {/* pb-24 on mobile accounts for the fixed bottom nav */}
      <main className="flex-1 pb-24 md:pb-0" key={loc.pathname}>
        <Outlet />
      </main>
      <CustomerFooter />
      <MiniCart />
      <MobileBottomNav />
    </div>
  );
}
